import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { BaselineCheckService } from '../../service/baseline-check.service';
import { BaselineCheckResponse } from '../../../../graphql/generated';
import { BaselineCheckActions } from './baseline-check.actions';


@Injectable()
export class BaselineCheckEffects {

  loadBaselineCheck$ = createEffect(
    (rs: BaselineCheckService = inject(BaselineCheckService)) => {
      return this.actions$.pipe(

        ofType(BaselineCheckActions.loadBaselineCheck),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.getBaselineCheck(parameters.legalEntityId, parameters.campaignId, parameters.params).pipe(
            map((baselineCheck) => {
              return BaselineCheckActions.loadBaselineCheckSuccess(
                { baselineCheck: baselineCheck as BaselineCheckResponse[], filtering: parameters.filtering }
              );
            }),
            catchError((error) => of(BaselineCheckActions.loadBaselineCheckFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateBaselineCheck$ = createEffect(
    (rs: BaselineCheckService = inject(BaselineCheckService)) => {
      return this.actions$.pipe(

        ofType(BaselineCheckActions.updateBaselineCheck),
        mergeMap((parameters) =>

          rs.updateBaselineCheck(parameters.id, parameters.icsRationale, parameters.irRationale).pipe(
            map((baselineCheck) => {
              return BaselineCheckActions.updateBaselineCheckSuccess(
                {
                  id: baselineCheck?.[0]?.cptCatalogue?.id ?? '',
                  cptId: parameters.id,
                  icsRationale: baselineCheck?.[0]?.icsRationale ?? '',
                  irRationale: baselineCheck?.[0]?.irRationale ?? '',
                  selection: parameters.selection
                }
              );
            }),
            catchError((error) => of(BaselineCheckActions.updateBaselineCheckFailure({ error, selection: parameters.selection, id: parameters?.id })))
          )
        )
      );
    },
    { functional: true }
  );

  createBaselineCheck$ = createEffect(
    (rs: BaselineCheckService = inject(BaselineCheckService)) => {
      return this.actions$.pipe(

        ofType(BaselineCheckActions.createBaselineCheck),
        mergeMap((parameters) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          rs.createBaselineCheck(parameters.campaignId, parameters.cptId, parameters.icsRationale, parameters.irRationale, parameters.legalEntityId).pipe(
            map((baselineCheck) => {
              return BaselineCheckActions.createBaselineCheckSuccess(
                {
                  icsRationale: baselineCheck?.icsRationale ?? '',
                  id: baselineCheck?.cptCatalogue?.id ?? '',
                  cptId: parameters.cptId,
                  irRationale: baselineCheck?.irRationale ?? '',
                  selection: parameters.selection
                }
              );
            }),
            catchError((error) => of(BaselineCheckActions.createBaselineCheckFailure({ error, selection: parameters.selection, id: parameters?.cptId })))
          )
        )
      );
    },
    { functional: true }
  );


  constructor(private actions$: Actions) { }
}
